import { Context, type Effect, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { BaselineSelection, BaselineSnapshot } from "./baseline-model.ts";
export interface WorkspaceChangesSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<BaselineSnapshot>>;
  readonly read: Effect.Effect<BaselineSnapshot>;
  readonly select: (selection: BaselineSelection) => Effect.Effect<void>;
}
export class WorkspaceChangesSessions extends Context.Service<WorkspaceChangesSessions, {
  readonly open: Effect.Effect<WorkspaceChangesSession, never, Scope.Scope>;
}>()("workerstation/frontend/WorkspaceChangesSessions") {}
